import {
  FETCH_CONNECTION,
  FETCH_CONNECTION_FAILURE,
  FETCH_CONNECTION_SUCCESS,
  SET_SORTER,
  SET_WAY,
  FETCH_DETAIL,
  FETCH_DETAIL_FAILURE,
  FETCH_DETAIL_SUCCESS,
  SET_OPENED_CONNECTION_DETAIL,
  FETCH_NEXT_CONNECTIONS,
  FETCH_NEXT_CONNECTION_FAILURE,
  FETCH_NEXT_CONNECTION_SUCCESS,
  FETCH_PREV_CONNECTIONS,
  FETCH_PREV_CONNECTION_FAILURE,
  FETCH_PREV_CONNECTION_SUCCESS,
} from './constants';

import Api from '../../services/api';
import { getProp } from '../../utilities';

export const requestConnection = () => ({
  type: FETCH_CONNECTION,
});

export const requestConnectionFailure = payload => ({
  type: FETCH_CONNECTION_FAILURE,
  payload,
});

export const requestConnectionSuccess = payload => ({
  type: FETCH_CONNECTION_SUCCESS,
  payload,
});

export const fetchConnectionFromTo = params => {
  return dispatch => {
    dispatch(requestConnection());
    const newParams = { ...params };
    if (newParams.ticketType === 'B') {
      newParams.ticketType = 'S';
    }
    if (newParams.ticketType === 'R') {
      Api.getConnectionsR(newParams)
        .then(res => {
          dispatch(requestConnectionSuccess(res));
        })
        .catch(error => {
          dispatch(requestConnectionFailure(error));
        });
    } else {
      Api.getConnections(newParams)
        .then(res => {
          dispatch(requestConnectionSuccess(res));
        })
        .catch(error => {
          dispatch(requestConnectionFailure(error));
        });
    }
  };
};

export const setSorter = sorter => ({
  type: SET_SORTER,
  payload: sorter,
});

export const setWay = way => ({
  type: SET_WAY,
  payload: way,
});

// detail spojenia
export const requestDetail = () => ({
  type: FETCH_DETAIL,
});

export const requestDetailFailure = payload => ({
  type: FETCH_DETAIL_FAILURE,
  payload,
});

export const requestDetailSuccess = (detail, id, connectionId) => ({
  type: FETCH_DETAIL_SUCCESS,
  payload: detail,
  id,
  connectionId,
});

export const fetchDetail = (id, fromStation, toStation, connectionId) => {
  return dispatch => {
    dispatch(requestDetail());
    Api.getConnectionDetail(id, fromStation, toStation)
      .then(res => {
        dispatch(requestDetailSuccess(res, id, connectionId));
      })
      .catch(error => {
        dispatch(requestDetailFailure(error));
      });
  };
};

export const setOpenedDetail = connectionId => ({
  type: SET_OPENED_CONNECTION_DETAIL,
  payload: connectionId,
});

// nacitanie dalsieho spojenia

const requestNextConnection = () => ({
  type: FETCH_NEXT_CONNECTIONS,
});

export const requestNextConnectionFailure = payload => ({
  type: FETCH_NEXT_CONNECTION_FAILURE,
  payload,
});

export const requestNextConnectionSuccess = payload => ({
  type: FETCH_NEXT_CONNECTION_SUCCESS,
  payload,
});
export const fetchNextConnections = date => {
  return (dispatch, getState) => {
    const state = getState();
    const params = getProp(state, ['connectionParams']);
    const currentStep = getProp(state, ['stepper', 'currentStep']);
    if (currentStep === 'secondWay') {
      params.endDate = date;
    } else {
      params.startDate = date;
    }
    dispatch(requestNextConnection());
    if (params.ticketType === 'B') {
      params.ticketType = 'S';
    }
    if (params.ticketType === 'R') {
      Api.getConnectionsR(params)
        .then(res => {
          dispatch(requestNextConnectionSuccess(res));
        })
        .catch(error => {
          dispatch(requestNextConnectionFailure(error));
        });
    } else {
      Api.getConnections(params)
        .then(res => {
          dispatch(requestNextConnectionSuccess(res));
        })
        .catch(error => {
          dispatch(requestNextConnectionFailure(error));
        });
    }
  };
};

// nacitanie predchadzajuceho spojenia

const requestPrevConnection = () => ({
  type: FETCH_PREV_CONNECTIONS,
});

export const requestPrevConnectionFailure = payload => ({
  type: FETCH_PREV_CONNECTION_FAILURE,
  payload,
});

export const requestPrevConnectionSuccess = payload => ({
  type: FETCH_PREV_CONNECTION_SUCCESS,
  payload,
});
export const fetchPrevConnections = (date, way) => {
  return (dispatch, getState) => {
    const state = getState();
    const params = getProp(state, ['connectionParams']);
    dispatch(requestPrevConnection());

    if (params.ticketType === 'R') {
      if (way === 1) {
        params.startDate = date;
      } else {
        params.endDate = date;
      }
      Api.getConnectionsR(params)
        .then(res => {
          dispatch(requestPrevConnectionSuccess(res));
        })
        .catch(error => {
          dispatch(requestPrevConnectionFailure(error));
        });
    } else {
      params.startDate = date;
      Api.getConnections(params)
        .then(res => {
          dispatch(requestPrevConnectionSuccess(res));
        })
        .catch(error => {
          dispatch(requestPrevConnectionFailure(error));
        });
    }
  };
};



// WEBPACK FOOTER //
// ./src/containers/Connections/actions.js